<template>
  <NuxtLayout >
    <NuxtLoadingIndicator color="primary"/>
    <NuxtPwaManifest />
    <NuxtPage/>
    <MoleculesQueuedToastQueueToastContainer />
  </NuxtLayout>
</template>
<script setup lang="ts">
</script>